export default __webpack_public_path__ + "static/media/480.cbcd8d5d.png";